import EarnedCard from './EarnedCard.vue'
export default EarnedCard